import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "expanded", "contentStyles", "render", "onExpandedChange", "onExpandedAllChange", "item", "itemKey", "itemIndex", "columns", "customStrings", "footerColumns", "bodyRowComponent", "renderRow", "noExpandableRowBody"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

const ExpandableRowBodyRow = _ref => {
  let {
    className,
    expanded,
    contentStyles,
    render,
    // eslint-disable-line no-unused-vars
    onExpandedChange,
    // eslint-disable-line no-unused-vars
    onExpandedAllChange,
    // eslint-disable-line react/prop-types, no-unused-vars
    item,
    itemKey,
    // eslint-disable-line react/prop-types, no-unused-vars
    itemIndex,
    // eslint-disable-line react/prop-types, no-unused-vars
    columns,
    // eslint-disable-line react/prop-types, no-unused-vars
    customStrings,
    // eslint-disable-line react/prop-types, no-unused-vars
    footerColumns,
    // eslint-disable-line react/prop-types, no-unused-vars,
    bodyRowComponent: TR,
    renderRow,
    noExpandableRowBody
  } = _ref,
      trProps = _objectWithoutProperties(_ref, _excluded);

  const renderExpandedContent = expanded && !noExpandableRowBody;
  const trClassName = clsx(className, {
    "pnr-table__row--expanded": renderExpandedContent
  });
  return _jsxs(React.Fragment, {
    children: [_jsx(TR, _objectSpread({
      className: trClassName,
      item: typeof TR === "function" ? item : null
    }, trProps)), renderExpandedContent && renderRow(itemKey, columns, item, render, customStrings, contentStyles)]
  });
};

ExpandableRowBodyRow.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The Component that renders the tr */
  bodyRowComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /** The CSS class name of the root element */
  className: PropTypes.string,

  /**
   * ExpandableRow content style (CSS-in-JS).
   */
  contentStyles: PropTypes.shape(),

  /**
   * Override for strings used within the component.
   */
  customStrings: PropTypes.shape({
    /**
     * Used for overriding default text `${itemKey}, expanded content`
     * of Expanded content of a single row.
     */
    rowExpandedLabel: PropTypes.func,

    /**
     * Used for overriding default textContent `${itemKey} details`
     * of visually hidden node inside Expanded content of a single row.
     */
    rowExpandedDetails: PropTypes.func
  }),

  /** If the row should be rendered as expanded */
  expanded: PropTypes.bool,

  /** The Row item to render */
  item: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /**
   * Event prop called when expanded state changes. It will receive
   * an object with these properties:
   * <ul>
   *  <li>
   *    `expanded`: Row's selected state.
   *  </li>
   *  <li>
   *    `expandedItemKey`: Returns the recently toggled row value as it relates to the `rowKey`.
   *  </li>
   *  <li>
   *    `expandedRows`: Array of expanded ids.
   *  </li>
   * </ul>
   */
  onExpandedChange: PropTypes.func,

  /**
   * Render Prop responsible for returning the expandable row content.
   * It will be invoked every time an expandable row is expanded
   * @param {Boolean} item Row item
   */
  render: PropTypes.func,

  /**
   * Render prop for rendering a custom expanded row
   * @param {Object} props - The props passed to this component.
   */
  renderRow: PropTypes.func
} : {};
ExpandableRowBodyRow.defaultProps = {
  render: null,
  onExpandedChange: null,
  item: null,
  className: "",
  customStrings: {},
  expanded: false,
  bodyRowComponent: "tr",
  contentStyles: {},
  // eslint-disable-next-line max-params
  renderRow: (itemKey, columns, item, render, customStrings, contentStyles) => {
    let childrowID = itemKey;
    childrowID && childrowID.toString().indexOf(" ") !== -1 && (childrowID = childrowID.toString().replace(/\s/g, ""));
    const expandedLabel = customStrings.rowExpandedLabel(`${itemKey}`, item);
    const expandedContent = customStrings.rowExpandedDetails(`${itemKey}`, item);
    return _jsx("tr", {
      className: "pnr-table__childrow",
      id: childrowID,
      children: _jsxs("td", {
        // eslint-disable-next-line react/prop-types
        colSpan: columns.length,
        className: "pnr-table__details",
        "aria-label": expandedLabel,
        css: contentStyles,
        children: [_jsx("span", {
          className: "wf-u-visually-hidden",
          children: expandedContent
        }), render && _jsx("div", {
          css: contentStyles.expandedRowChild,
          className: "pnr-table__expandable-row-content",
          children: render(item)
        })]
      })
    });
  }
};
export default ExpandableRowBodyRow;